// !!! THIS FILE IS GENERATED BY codegen.js !!!

export const ma0 = {
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
}

export const ma1 = {
  marginTop: 6,
  marginRight: 6,
  marginBottom: 6,
  marginLeft: 6,
}

export const ma2 = {
  marginTop: 8,
  marginRight: 8,
  marginBottom: 8,
  marginLeft: 8,
}

export const ma3 = {
  marginTop: 12,
  marginRight: 12,
  marginBottom: 12,
  marginLeft: 12,
}

export const ma4 = {
  marginTop: 18,
  marginRight: 18,
  marginBottom: 18,
  marginLeft: 18,
}

export const ma5 = {
  marginTop: 24,
  marginRight: 24,
  marginBottom: 24,
  marginLeft: 24,
}

export const ma6 = {
  marginTop: 36,
  marginRight: 36,
  marginBottom: 36,
  marginLeft: 36,
}

export const ma7 = {
  marginTop: 60,
  marginRight: 60,
  marginBottom: 60,
  marginLeft: 60,
}

export const ma8 = {
  marginTop: 90,
  marginRight: 90,
  marginBottom: 90,
  marginLeft: 90,
}

export const mh0 = {
  marginLeft: 0,
  marginRight: 0,
}

export const mh1 = {
  marginLeft: 6,
  marginRight: 6,
}

export const mh2 = {
  marginLeft: 8,
  marginRight: 8,
}

export const mh3 = {
  marginLeft: 12,
  marginRight: 12,
}

export const mh4 = {
  marginLeft: 18,
  marginRight: 18,
}

export const mh5 = {
  marginLeft: 24,
  marginRight: 24,
}

export const mh6 = {
  marginLeft: 36,
  marginRight: 36,
}

export const mh7 = {
  marginLeft: 60,
  marginRight: 60,
}

export const mh8 = {
  marginLeft: 90,
  marginRight: 90,
}

export const mv0 = {
  marginTop: 0,
  marginBottom: 0,
}

export const mv1 = {
  marginTop: 6,
  marginBottom: 6,
}

export const mv2 = {
  marginTop: 8,
  marginBottom: 8,
}

export const mv3 = {
  marginTop: 12,
  marginBottom: 12,
}

export const mv4 = {
  marginTop: 18,
  marginBottom: 18,
}

export const mv5 = {
  marginTop: 24,
  marginBottom: 24,
}

export const mv6 = {
  marginTop: 36,
  marginBottom: 36,
}

export const mv7 = {
  marginTop: 60,
  marginBottom: 60,
}

export const mv8 = {
  marginTop: 90,
  marginBottom: 90,
}

export const mt0 = {
  marginTop: 0,
}

export const mt1 = {
  marginTop: 6,
}

export const mt2 = {
  marginTop: 8,
}

export const mt3 = {
  marginTop: 12,
}

export const mt4 = {
  marginTop: 18,
}

export const mt5 = {
  marginTop: 24,
}

export const mt6 = {
  marginTop: 36,
}

export const mt7 = {
  marginTop: 60,
}

export const mt8 = {
  marginTop: 90,
}

export const mr0 = {
  marginRight: 0,
}

export const mr1 = {
  marginRight: 6,
}

export const mr2 = {
  marginRight: 8,
}

export const mr3 = {
  marginRight: 12,
}

export const mr4 = {
  marginRight: 18,
}

export const mr5 = {
  marginRight: 24,
}

export const mr6 = {
  marginRight: 36,
}

export const mr7 = {
  marginRight: 60,
}

export const mr8 = {
  marginRight: 90,
}

export const mb0 = {
  marginBottom: 0,
}

export const mb1 = {
  marginBottom: 6,
}

export const mb2 = {
  marginBottom: 8,
}

export const mb3 = {
  marginBottom: 12,
}

export const mb4 = {
  marginBottom: 18,
}

export const mb5 = {
  marginBottom: 24,
}

export const mb6 = {
  marginBottom: 36,
}

export const mb7 = {
  marginBottom: 60,
}

export const mb8 = {
  marginBottom: 90,
}

export const ml0 = {
  marginLeft: 0,
}

export const ml1 = {
  marginLeft: 6,
}

export const ml2 = {
  marginLeft: 8,
}

export const ml3 = {
  marginLeft: 12,
}

export const ml4 = {
  marginLeft: 18,
}

export const ml5 = {
  marginLeft: 24,
}

export const ml6 = {
  marginLeft: 36,
}

export const ml7 = {
  marginLeft: 60,
}

export const ml8 = {
  marginLeft: 90,
}

export const pa0 = {
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
}

export const pa1 = {
  paddingTop: 6,
  paddingRight: 6,
  paddingBottom: 6,
  paddingLeft: 6,
}

export const pa2 = {
  paddingTop: 8,
  paddingRight: 8,
  paddingBottom: 8,
  paddingLeft: 8,
}

export const pa3 = {
  paddingTop: 12,
  paddingRight: 12,
  paddingBottom: 12,
  paddingLeft: 12,
}

export const pa4 = {
  paddingTop: 18,
  paddingRight: 18,
  paddingBottom: 18,
  paddingLeft: 18,
}

export const pa5 = {
  paddingTop: 24,
  paddingRight: 24,
  paddingBottom: 24,
  paddingLeft: 24,
}

export const pa6 = {
  paddingTop: 36,
  paddingRight: 36,
  paddingBottom: 36,
  paddingLeft: 36,
}

export const pa7 = {
  paddingTop: 60,
  paddingRight: 60,
  paddingBottom: 60,
  paddingLeft: 60,
}

export const pa8 = {
  paddingTop: 90,
  paddingRight: 90,
  paddingBottom: 90,
  paddingLeft: 90,
}

export const ph0 = {
  paddingLeft: 0,
  paddingRight: 0,
}

export const ph1 = {
  paddingLeft: 6,
  paddingRight: 6,
}

export const ph2 = {
  paddingLeft: 8,
  paddingRight: 8,
}

export const ph3 = {
  paddingLeft: 12,
  paddingRight: 12,
}

export const ph4 = {
  paddingLeft: 18,
  paddingRight: 18,
}

export const ph5 = {
  paddingLeft: 24,
  paddingRight: 24,
}

export const ph6 = {
  paddingLeft: 36,
  paddingRight: 36,
}

export const ph7 = {
  paddingLeft: 60,
  paddingRight: 60,
}

export const ph8 = {
  paddingLeft: 90,
  paddingRight: 90,
}

export const pv0 = {
  paddingTop: 0,
  paddingBottom: 0,
}

export const pv1 = {
  paddingTop: 6,
  paddingBottom: 6,
}

export const pv2 = {
  paddingTop: 8,
  paddingBottom: 8,
}

export const pv3 = {
  paddingTop: 12,
  paddingBottom: 12,
}

export const pv4 = {
  paddingTop: 18,
  paddingBottom: 18,
}

export const pv5 = {
  paddingTop: 24,
  paddingBottom: 24,
}

export const pv6 = {
  paddingTop: 36,
  paddingBottom: 36,
}

export const pv7 = {
  paddingTop: 60,
  paddingBottom: 60,
}

export const pv8 = {
  paddingTop: 90,
  paddingBottom: 90,
}

export const pt0 = {
  paddingTop: 0,
}

export const pt1 = {
  paddingTop: 6,
}

export const pt2 = {
  paddingTop: 8,
}

export const pt3 = {
  paddingTop: 12,
}

export const pt4 = {
  paddingTop: 18,
}

export const pt5 = {
  paddingTop: 24,
}

export const pt6 = {
  paddingTop: 36,
}

export const pt7 = {
  paddingTop: 60,
}

export const pt8 = {
  paddingTop: 90,
}

export const pr0 = {
  paddingRight: 0,
}

export const pr1 = {
  paddingRight: 6,
}

export const pr2 = {
  paddingRight: 8,
}

export const pr3 = {
  paddingRight: 12,
}

export const pr4 = {
  paddingRight: 18,
}

export const pr5 = {
  paddingRight: 24,
}

export const pr6 = {
  paddingRight: 36,
}

export const pr7 = {
  paddingRight: 60,
}

export const pr8 = {
  paddingRight: 90,
}

export const pb0 = {
  paddingBottom: 0,
}

export const pb1 = {
  paddingBottom: 6,
}

export const pb2 = {
  paddingBottom: 8,
}

export const pb3 = {
  paddingBottom: 12,
}

export const pb4 = {
  paddingBottom: 18,
}

export const pb5 = {
  paddingBottom: 24,
}

export const pb6 = {
  paddingBottom: 36,
}

export const pb7 = {
  paddingBottom: 60,
}

export const pb8 = {
  paddingBottom: 90,
}

export const pl0 = {
  paddingLeft: 0,
}

export const pl1 = {
  paddingLeft: 6,
}

export const pl2 = {
  paddingLeft: 8,
}

export const pl3 = {
  paddingLeft: 12,
}

export const pl4 = {
  paddingLeft: 18,
}

export const pl5 = {
  paddingLeft: 24,
}

export const pl6 = {
  paddingLeft: 36,
}

export const pl7 = {
  paddingLeft: 60,
}

export const pl8 = {
  paddingLeft: 90,
}
